import * as React from 'react'

export const UnderlineIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M2.35709 21.1997V23.6997H21.8571V21.1997H2.35709ZM19.4196 1.19971V11.1997C19.4196 13.1888 18.6492 15.0965 17.2778 16.503C15.9064 17.9095 14.0465 18.6997 12.1071 18.6997C10.1677 18.6997 8.30773 17.9095 6.93637 16.503C5.56501 15.0965 4.79459 13.1888 4.79459 11.1997V1.19971H8.45084V11.1997C8.45084 13.2672 10.0913 14.9497 12.1071 14.9497C14.1229 14.9497 15.7633 13.2672 15.7633 11.1997V1.19971H19.4196Z'
        fill='currentColor'
      />
    </svg>
  )
})

UnderlineIcon.displayName = 'UnderlineIcon'
